import React, { useEffect } from 'react';
import { App } from 'antd';
import { setMessageApi } from '../utils/messageInstance';

const MessageProvider = ({ children }) => {
  const { message } = App.useApp();

  useEffect(() => {
    // 将 message API 设置到全局实例中
    setMessageApi(message);
  }, [message]);

  return children;
};

export default MessageProvider;
